import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';

const MdmModal = () => import(
/* webpackChunkName: "modal" */
'~/components/atoms/Global/MdmModal.vue');

export default {
  name: 'Mentions',
  components: {
    MdmModal
  },

  data() {
    return {
      showModal: false
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    getDate() {
      const d = new Date();
      return d.getFullYear();
    },

    setLocale() {
      return "".concat(this.locale.market, "/").concat(this.locale.language);
    }

  })
};